import classNames from 'classnames';
import PropTypes from 'prop-types';

import Content from './content';

import classes from './index.module.css';

const propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.node,
  icon: PropTypes.string,
  link: PropTypes.string,
  alt: PropTypes.string,
  onClick: PropTypes.func,
  isFullBodyLink: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isHiddenDesktop: PropTypes.bool,
  noShadow: PropTypes.bool,
  isTimeline: PropTypes.bool,
  footer: PropTypes.element,
  containerClassName: PropTypes.string,
};

const defaultProps = {
  link: '',
  alt: '',
  icon: undefined,
  isFullBodyLink: false,
  isDisabled: false,
  noShadow: false,
  onClick: null, // this will prevent the card from being stuck to interactive case
  footer: null,
  isHiddenDesktop: false,
  title: '',
  value: '',
  isTimeline: false,
  containerClassName: '',
};

export function SideCard({
  link = defaultProps.link,
  isFullBodyLink = defaultProps.isFullBodyLink,
  onClick = defaultProps.onClick,
  isDisabled = defaultProps.isDisabled,
  noShadow = defaultProps.noShadow,
  footer = defaultProps.footer,
  isHiddenDesktop = defaultProps.isHiddenDesktop,
  isTimeline = defaultProps.isTimeline,
  containerClassName = defaultProps.containerClassName,
  ...rest
}) {
  // Anton comment on FRON-13151 https://zippia.atlassian.net/browse/FRON-13151?focusedCommentId=153160
  /**
   * when we have an additional "view more" button or something like that, the title should be greyed out.
   * when we do not have an additional component to interact with, this role is taken over by the title and it should be blue.
   */
  const isInteractive = !footer && !isTimeline;

  if (link) {
    return (
      <a
        id="aside-card"
        href={link}
        target="_blank"
        data-title={rest.title}
        data-value={rest.value}
        className={classNames(
          'd-flex justify-content-between pointer z-br-4 z-py-20 z-px-20',
          classes.card,
          classes.interactive,
          {
            [classes.noShadow]: noShadow,
          },
          containerClassName,
        )}
        rel="noreferrer"
      >
        <Content {...rest} />
      </a>
    );
  }

  if (isDisabled) {
    return (
      <div
        id="aside-card"
        className={classNames(
          'd-flex justify-content-between z-br-4 z-py-20 z-px-20',
          classes.card,
          classes.disabled,
          {
            [classes.noShadow]: noShadow,
          },
          containerClassName,
        )}
        data-title={rest.title}
        data-value={rest.value}
      >
        <Content {...rest} />
      </div>
    );
  }

  return (
    <div
      id="aside-card"
      className={classNames('z-br-4 z-py-20 z-px-20', classes.card, {
        [classes.interactive]: isInteractive,
        pointer: isInteractive,
        [classes.full]: isFullBodyLink,
        [classes.noShadow]: noShadow,
        [classes.hasFooter]: footer,
        [classes.hideDesktop]: isHiddenDesktop,
      },
      containerClassName,
      )}
      onClick={onClick}
      data-title={rest.title}
      data-value={rest.value}
    >
      <div className="d-flex justify-content-between">
        <Content {...rest} isInteractive={isInteractive} isTimeline={isTimeline} />
      </div>
      {footer && <div>{footer} </div>}
    </div>
  );
}

SideCard.propTypes = propTypes;
SideCard.defaultProps = defaultProps;
